import React from 'react';
import { useEffect, useState } from 'react';
import z from 'zod/v4';
import { Button, Checkbox, Input } from './index.js';
const ZodForm = ({ schema, initialData, onSubmit, }) => {
    const [formData, setFormData] = useState(initialData || {});
    const [errors, setErrors] = useState(null);
    useEffect(() => {
        setFormData(initialData || {});
    }, [schema, initialData]);
    const handleChange = (key, value) => {
        setFormData((prev) => ({ ...prev, [key]: value }));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const parsedData = schema.safeParse(formData);
        if (!parsedData.success) {
            setErrors(parsedData.error);
            return;
        }
        setErrors(null);
        onSubmit(parsedData.data);
    };
    return (React.createElement("div", null,
        Object.entries(schema.shape).map(([key, field]) => {
            return renderField(field, key, formData[key], (value) => handleChange(key, value));
        }),
        errors && errors.issues.length > 0 && (React.createElement("div", { style: {
                background: '#fff0f0',
                border: '1px solid #ffcccc',
                borderRadius: '8px',
                padding: '1em',
                margin: '1em 0',
                boxShadow: '0 2px 8px rgba(255,0,0,0.05)',
            } },
            React.createElement("h4", { style: {
                    color: '#d32f2f',
                    marginBottom: '0.5em',
                    marginTop: 0,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5em',
                } }, "Validation Errors"),
            React.createElement("ul", { style: { listStyle: 'none', padding: 0, margin: 0 } }, errors.issues.map((issue) => {
                let title = '';
                let field = schema;
                for (const segment of issue.path) {
                    if (field instanceof z.ZodObject) {
                        field = field.shape[segment];
                        title = field.meta()?.title || segment.toString();
                    }
                    else {
                        title = segment.toString();
                    }
                }
                return (React.createElement("li", { key: issue.path.join('.'), style: {
                        marginBottom: '0.75em',
                        padding: '0.75em',
                        background: '#ffeaea',
                        borderRadius: '6px',
                        borderLeft: '4px solid #d32f2f',
                        boxShadow: '0 1px 4px rgba(211,47,47,0.05)',
                    } },
                    React.createElement("span", { style: { fontWeight: 'bold', color: '#d32f2f' } }, title),
                    React.createElement("span", { style: { marginLeft: '0.5em', color: '#333' } }, issue.message)));
            })))),
        React.createElement(Button, { onClick: handleSubmit }, "Submit")));
};
const unwrapZodType = (type) => {
    if (type instanceof z.ZodOptional || type instanceof z.ZodNullable) {
        return unwrapZodType(type.unwrap());
    }
    return type;
};
const renderField = (field, key, value, onChange) => {
    const meta = field.meta();
    field = unwrapZodType(field);
    if (field instanceof z.ZodDefault) {
        if (value === undefined) {
            value = field.def.defaultValue;
        }
        field = unwrapZodType(field.unwrap());
    }
    if (field instanceof z.ZodObject) {
        return (React.createElement("div", { key: key },
            React.createElement("h4", null, meta?.title || key),
            Object.entries(field.shape).map(([subKey, subField]) => {
                return renderField(subField, `${key}.${subKey}`, value ? value[subKey] : undefined, (val) => {
                    onChange({ ...value, [subKey]: val });
                });
            })));
    }
    if (field instanceof z.ZodString) {
        return (React.createElement(Input, { key: key, placeholder: meta?.title, value: value || '', onChange: (e) => onChange(e.target.value) }));
    }
    if (field instanceof z.ZodBoolean) {
        return (React.createElement(Checkbox, { key: key, placeholder: meta?.title || key, checked: value || false, onChange: (e) => onChange(e.target.checked) }));
    }
    // Unsupported field type
    return (React.createElement("div", { key: key },
        React.createElement("p", null,
            "\u26A0\uFE0F ",
            meta?.title || key,
            " is not supported yet. Please implement support for this field type. ",
            field.def.type)));
};
export default ZodForm;
//# sourceMappingURL=ZodForm.js.map